import { SALES_PERSON_FRAGMENT } from "./fragments";

export const GET_SALES_PEOPLE = `
${SALES_PERSON_FRAGMENT}
query SalesPeople($page:ID, $q:String, $department: String) {
    salesPeople(page: $page, q:$q, department:$department) {
        count
        results{
          ...SalesPersonParts
        }
        errors{
          description
        }
    }
  }
`;


export const CREATE_USER = `
  mutation CreateUser($name:String!, $email:String!, $departmentId:ID!, $roleId:ID!,) {
    createUser(name: $name, email:$email, departmentId:$departmentId, roleId: $roleId){
      user {
        id
        name
        email
        department {
          id
          name
        }
        role {
          id
          name
        }
      }
      errors {
        property
        description
      }
    }
  }
`;

export const UPDATE_USER = `
mutation UpdateUser($id: ID!, $name:String!, $email:String!, $departmentId:ID!, $roleId:ID!,) {
  updateUser(id: $id, name: $name, email:$email, departmentId:$departmentId, roleId: $roleId){
    user {
      id
      name
      email
      department {
        id
        name
      }
      role {
        id
        name
      }
    }
    errors {
      property
      description
    }
  }
}

`;

export const GET_USER = `
  query GetUser($id:ID!) {
    user(id: $id ){
      id
      name
      email
      department {
        id
        name
      }
      role {
        id
        name
      }
    }
  }
`;

export const GET_CURRENT_USER = `
query {
  currentUser {
    id
    name
    email
    role {
      id
      name
    }
    entitlements {
      id
      name
      entityExceptions {
        id
        entityId
        user {
          id
          email
        }
        exceptionType
      }
    }
    department {
      id
      name
    }
    userNotifications {
      id
      message
      createdAt
    }
  }
}
`;

export const DELETE_USER = `
  mutation DeleteUser($id:ID!) {
    deleteUser(id: $id ){
      result
      errors {
        property
        description
      }
    }
  }
`;

export const GET_USER_WITH_API_KEYS = `
  query GetUser($id:ID!) {
    user(id: $id ){
      id
      name
      email
      department {
        id
        name
      }
      apiKeys {
        id
        key
      }
      role {
        id
        name
      }
    }
  }
`;

export const GENERATE_API_KEY = `
  mutation GenerateAPiKey($userId:ID!) {
    generateApiKey(userId: $userId ){
      apiKey {
        id
        key
      }
      errors {
        property
        description
      }
    }
  }
`;

export const DELETE_API_KEY = `
  mutation DeleteApiKey($apiKeyId:ID!) {
    deleteApiKey(apiKeyId: $apiKeyId ){
      result
      errors {
        property
        description
      }
    }
  }
`;

export const ALL_USERS_QUERY = `
query($page:ID, $q: String) {
  users(page: $page, q: $q) {
      count
      results{
        id
        name
      }
      errors{
        description
      }
  }
}
`;

export const USERS_BY_ROLE_QUERY = `
query($page:ID, $q: String, $role: String) {
  users(page: $page, q: $q, role: $role) {
      count
      results{
        id
        name
      }
      errors{
        description
      }
  }
}
`;
